import { useEffect } from 'react';
import { useActions } from 'lib/hooks';
import { LatestRef } from './types';
import { ALERT_MESSAGE, ALERT_TYPES } from 'config/constants';
import { setTimeout } from 'lib/window';

export function useAmendmentConfirmedFlow(ref: LatestRef) {
  const actions = useActions();

  const { amendment } = ref.current;

  useEffect(() => {
    if (amendment?.state !== 'ACCEPTED') return;

    const { booking, navigateTo } = ref.current;

    // Navigate in the next tick to allow a page view to be recorded with /confirmed suffix
    // see: ./useSyncUrlWithState.ts
    // This hack can be removed when a real confirmation page is built
    setTimeout(() => {
      navigateTo.booking('replace', booking.id);
      actions.alert.displayAlert({ type: ALERT_TYPES.SUCCESS, message: ALERT_MESSAGE.CHANGE_DATE_SUCCESS });
    }, 1);
  }, [ref, amendment?.state, actions.alert]);
}
